<hr class="margin-0" />
<div>
    <!--AD VISIBILITY Targeting Component -->
    <ad-visibility [group]="group" [formArray]="formArray">
    </ad-visibility>

    <!--ADS.TXT Targeting Component -->
    <ads-txt-status [group]="group" [formArray]="formArray">
    </ads-txt-status>

    <!--APP LIST Targeting Component -->
    <market-app-list [group]="group" [formArray]="formArray" [advertiserInfo]="advertiserInfo">
    </market-app-list>

    <!--AUDIENCE SEGMENTS Targeting Component -->
    <audience-targeting [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
    </audience-targeting>

    <!--BID PRICE Targeting Component -->
    <bid-price [group]="group" [formArray]="formArray" [advertiserInfo]="advertiserInfo"></bid-price>

    <!-- BRAND SAFETY Targeting Component -->
    <brand-safety [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
    </brand-safety>

    <!-- CONTEXTUAL Targeting Component -->
    <contextual [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
    </contextual>

    <daypart-targeting [group]="group" [formArray]="formArray">
    </daypart-targeting>

    <!--DEVICES Targeting Component -->
    <devices [group]="group" [formArray]="formArray" [isNew]="isNew"></devices>
    <!--FREQUENCY- Targeting Component -->
    <frequency-cap [group]="group" [formArray]="formArray"></frequency-cap>

    <ccp-geo-targeting [group]="group" [formArray]="formArray"></ccp-geo-targeting>

    <!-- PAGE QUALITY Targeting Component -->
    <page-quality [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
    </page-quality>

    <!--PLAYER SIZE Targeting Component -->
    <player-size [group]="group" [formArray]="formArray">
    </player-size>

    <!--SITE LIST Targeting Component -->
    <market-site-list [group]="group" [formArray]="formArray" [advertiserInfo]="advertiserInfo">
    </market-site-list>

</div>
